
import { defineComponent } from "vue"


export default defineComponent({
  name: 'task-scenetype2-execution',
})
